import request from '@/utils/request'

// 查询用户提现账户分页
export function pageUserWithdrawalAccount(query) {
  return request({
    url: '/biz/user/withdrawal/account/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户提现账户列表
export function listUserWithdrawalAccount(query) {
  return request({
    url: '/biz/user/withdrawal/account/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户提现账户详细
export function getUserWithdrawalAccount(id) {
  return request({
    url: '/biz/user/withdrawal/account/detail',
    method: 'get',
    params: { id }
  })
}

// 新增用户提现账户
export function addUserWithdrawalAccount(data) {
  return request({
    url: '/biz/user/withdrawal/account/add',
    method: 'post',
    data
  })
}

// 修改用户提现账户
export function updateUserWithdrawalAccount(data) {
  return request({
    url: '/biz/user/withdrawal/account/edit',
    method: 'post',
    data
  })
}

// 删除用户提现账户
export function delUserWithdrawalAccount(ids) {
  return request({
    url: '/biz/user/withdrawal/account/delete',
    method: 'post',
    data: ids
  })
}
